"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createModelProvider = void 0;
const traverse_model_values_1 = __importDefault(require("../utils/traverse-model-values"));
const selectors_1 = require("../modules/selectors");
const render_to_xml_1 = __importDefault(require("../utils/render-to-xml"));
const forms_v2_1 = require("@icg360/forms-v2");
const createModelProvider = (state, options) => (modelId) => {
    const form = (0, selectors_1.useFormOrCurrent)(state, { useForm: options });
    if (state.rex.version[form.id] > 1) {
        if (options.type === 'XML') {
            return '';
        }
        return formModelJSON(state, form.id, !modelId || modelId === 'default');
    }
    const model = state.rex.models[form.id][form.index];
    if (!model)
        return {};
    return options.type === 'JSON'
        ? (0, traverse_model_values_1.default)({ model, modelId, options })
        : (0, render_to_xml_1.default)({
            model,
            modelId,
            onlyChanged: options.onlyChanged,
        });
};
exports.createModelProvider = createModelProvider;
function formModelJSON(state, modelKey, isDefault) {
    const values = {};
    const invalidModels = [];
    const changed = [];
    (0, forms_v2_1.eachTerm)(state.rex.formModel, modelKey, (key, termState, term) => {
        if (isDefault && (term.sync === 'none' || term.sync === 'pull'))
            return;
        if (!termState) {
            // This doesn't tell the whole story,
            // we might lose an interable instance but not count them as changed
            values[key] = term.default || '';
            return;
        }
        values[key] = termState.value;
        if (termState.isRelevant &&
            termState.isValid === false &&
            termState.validation.some((v) => !v.pass && v.type !== 'enum-option')) {
            invalidModels.push(key);
        }
        if (termState.value !== termState.initial) {
            changed.push(key);
        }
    });
    return {
        values,
        isValid: invalidModels.length === 0,
        invalidModels,
        changed,
    };
}
//# sourceMappingURL=create-model-provider.js.map